import { useQuery } from '@tanstack/react-query';

import { getActivePatientSubscriptionByUserID } from 'services/patientSubscription';
import { PatientSubscriptionStatusType } from 'services/patientSubscription/types';

import { patientSubscriptionStatusSchema } from '../subscriptionSchema';

interface UseSubscriptionStatusProps {
  patientCognitoId: string;
  isSubscriptionModel: boolean;
}
export function useSubscriptionStatus({
  patientCognitoId,
  isSubscriptionModel,
}: UseSubscriptionStatusProps) {
  const { data: patientSubscriptionStatus, isLoading } = useQuery({
    queryKey: ['patientSubscriptionStatusType', patientCognitoId],
    queryFn: () => getActivePatientSubscriptionByUserID(patientCognitoId),
    enabled: isSubscriptionModel,
  });

  const statusSchema =
    patientSubscriptionStatusSchema[
      patientSubscriptionStatus?.status ?? 'UNSUBSCRIBED'
    ];

  const expiredAt =
    patientSubscriptionStatus?.status === PatientSubscriptionStatusType.TRIAL
      ? patientSubscriptionStatus?.trialExpiresAt
      : patientSubscriptionStatus?.expiresAt;

  return {
    subscriptionStatus: {
      statusSchema,
      expiredAt,
    },
    isLoading,
  };
}
